export enum ELocalStorageItems {
    crmAccessToken = 'crmAccessToken',
    crmRefreshToken = 'crmRefreshToken',
    crmIdToken = 'crmIdToken'

}